<template>
  <div id="app" >
    <keep-alive v-if="isRouterAlive">
        <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  // 跳转首页刷新页面
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
  @import './common/font/font.css';
  /* .el-submenu{
    margin-top: 5px;
    border-radius: 4px;
    text-indent: 20px;
  }
  .el-menu--inline{
    width: 100%;
    height: 100%;
    border: 1px solid #000;
  } */

</style>



// WEBPACK FOOTER //
// src/App.vue